const UUID_PATTERN = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const SHARE_TOKEN_PATTERN = /\/share\/[a-f0-9]{32,}/gi;
const NUMERIC_ID_PATTERN = /\/\d+(?=\/|$)/g;
// Low-cardinality route templates for PostHog + GCP log-based metrics. See docs/monitoring/README.md §Troubleshooting if you add a new ID shape (ULID, short hash, etc.).
export function toPathTemplate(path) {
    return (path || '')
        .split('?')[0]
        .replace(UUID_PATTERN, '/:id')
        .replace(SHARE_TOKEN_PATTERN, '/share/:token')
        .replace(NUMERIC_ID_PATTERN, '/:n');
}
// Frontend wrapper: prefixes HTTP method. Backend logs method as a separate field.
export function toRouteTemplate(method, url) {
    return `${method.toUpperCase()} ${toPathTemplate(url)}`;
}
//# sourceMappingURL=routeTemplate.js.map